"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
function GlyphsDirective($timeout, config, book, glyphMatcher, preview) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/glyphs.html',
        controller: /** @class */ (function (_super) {
            __extends(GlyphsController, _super);
            function GlyphsController($scope, book) {
                'ngInject';
                var _this = _super.call(this, $scope, book) || this;
                _this.slickSettings = {
                    infinite: false,
                    draggable: false,
                    slidesToScroll: 1,
                    variableWidth: true,
                    prevArrow: '<div class="pb-carousel-arrow pb-carousel-arrow-left"></div>',
                    nextArrow: '<div class="pb-carousel-arrow pb-carousel-arrow-right"></div>',
                    methods: {}
                };
                _this.slickEnabled = true;
                _this.letterCtrlID = _this.id.replace(/(_abc)$/gi, '');
                $scope.$watch(function () { return _this.getGlyphs(); }, _this.onGlyphUpdate.bind(_this));
                return _this;
            }
            GlyphsController.prototype.onGlyphUpdate = function (glyphs) {
                this.glyphs = glyphs;
                this.saveGlyphs();
                this.letters = this.getLetters();
                this.reinitializeSlick();
            };
            GlyphsController.prototype.saveGlyphs = function () {
                var glyphObj = this.getGlyphs();
                var glyphArr = [];
                for (var _i = 0, glyphObj_1 = glyphObj; _i < glyphObj_1.length; _i++) {
                    var glyph = glyphObj_1[_i];
                    glyphArr.push(glyph.value);
                }
                this.book.set(this.prefix, this.id, glyphArr);
            };
            GlyphsController.prototype.getLetters = function () {
                return glyphMatcher.getLetters(this.prefix, this.letterCtrlID);
            };
            GlyphsController.prototype.getGlyphs = function () {
                return glyphMatcher.getGlyphs(this.prefix, this.letterCtrlID);
            };
            GlyphsController.prototype.getGlyphByIndex = function (index) {
                return this.glyphs[index];
            };
            GlyphsController.prototype.isSpecialChar = function (glyph) {
                return glyph.value === 'leerzeichen'
                    || glyph.value === 'bindestrich'
                    || glyph.value === 'accent';
            };
            GlyphsController.prototype.switchGlyph = function (index) {
                var glyph = this.getGlyphByIndex(index);
                if (this.isSpecialChar(glyph)) {
                    return;
                }
                if (glyph.alternatives > 0) {
                    glyphMatcher.switchGlyph(this.prefix, this.letterCtrlID, index);
                    this.saveGlyphs();
                }
                $timeout(function () {
                    var active = preview.getActive().id, id = preview.multipages[0].id + (index + 1) / 100, animate = active !== id;
                    preview.setActive(id, animate);
                });
            };
            GlyphsController.prototype.getGlyphImage = function (index) {
                var glyph = this.getGlyphByIndex(index);
                return config.params.assets + "/" + glyph.image;
            };
            GlyphsController.prototype.reinitializeSlick = function () {
                var _this = this;
                this.slickEnabled = false;
                $timeout(function () {
                    _this.slickEnabled = true;
                });
            };
            return GlyphsController;
        }(form_1.FormOptionController)),
        controllerAs: 'glyphsCtrl'
    };
}
exports.GlyphsDirective = GlyphsDirective;
